<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      modal-size="full-width"
      :modalBackdrop="modalBackdrop"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="form-group row align-items-center">
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("company_name") }}
            </label>
            <app-input
              id="company_name"
              class="col-sm-3"
              type="text"
              v-model="inputs.company_name"
              :required="true"
            />
            <label for="comapny_number" class="col-sm-3 mb-0">
              {{ $t("company_number") }}
            </label>
            <app-input
              id="company_number"
              class="col-sm-3"
              type="text"
              v-model="inputs.comapny_number"
              :required="true"
            />
          </div>

          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("country") }}
            </label>
            <app-input
              id="country"
              class="col-sm-3"
              type="text"
              v-model="inputs.country"
              :required="true"
            />
            <label for="postal_code" class="col-sm-3 mb-0">
              {{ $t("postal_code") }}
            </label>
            <app-input
                id="postal_code"
                class="col-sm-3"
                type="text"
                v-model="inputs.postal_code"
                :required="true"
            />
          </div>

          <div class="form-group row align-items-center">
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("first_name") }}
            </label>
            <app-input
              id="first_name"
              class="col-sm-3"
              type="text"
              v-model="inputs.company_admin.first_name"
              :required="true"
            />
            <label for="inputs_name" class="col-sm-3 mb-0">
              {{ $t("last_name") }}
            </label>
            <app-input
              id="name"
              class="col-sm-3"
              type="text"
              v-model="inputs.company_admin.last_name"
              :required="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("email") }}
            </label>
            <app-input
              id="email"
              class="col-sm-3"
              type="email"
              v-model="inputs.company_admin.email"
              :required="true"
            />
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("contact_number") }}
            </label>
            <app-input
              id="contact"
              class="col-sm-3"
              type="tel-input"
              v-model="inputs.company_admin.phone"
              :placeholder="$t('type_contact_number')"
              :required="true"
            />
            </div>
          <div class="form-group row align-items-center" v-if="!companyData.company_admin.first_name">
            <label for="password" class="col-sm-3 mb-0">
              {{ $t("password") }}
            </label>
            <app-input
                class="col-sm-3"
              type="password"
              :required="true"
              :specialValidation="true"
              v-model="inputs.company_admin.password"
            />
            <app-input
              type="hide"
              v-model="inputs.company_admin.confirm_password"
              same-as="inputs_password"
            />
          </div>
          <app-input v-if="inputs.id"
              type="hide"
              v-model="inputs.id"
              same-as="inputs_password"
          />
          <app-input v-if="inputs.id"
                     type="hide"
                     v-model="inputs.company_admin.id"
                     same-as="inputs_password"
          />
        </form>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button>
        <button
          type="button"
          class="btn btn-primary mr-2"
          data-dismiss="modal"
          @click="submit"
        >
          {{ $t("submit") }}
        </button>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper";
import {
  CUSTOMER_ROLE,
  CUSTOMER_STORE,
  CUSTOMER_UPDATE,
  USERS,
} from "../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyData: {
      type: Object,
      default: {}
    },

  },
  data() {
    return {
      preloader: false,
      inputs: this.companyData,
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      modalBackdrop: false,
    };
  },
  created() {
    console.log("data -", this.inputs)
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }

  },
  methods: {

    submit() {
      let requestPayload = {
        company:{
          id: this.inputs.id??'',
          company_name : this.inputs.company_name,
          comapny_number : this.inputs.comapny_number,
          company_number : this.inputs.comapny_number,
          address : this.inputs.address,
          address_line_1 : this.inputs.address_line_1,
          address_line_2 : this.inputs.address_line_2,
          country : this.inputs.country,
          postal_code : this.inputs.postal_code,
          locality : this.inputs.locality,
        },
        user: {
          id: this.inputs.id??'',
          first_name : this.inputs.company_admin.first_name,
          last_name : this.inputs.company_admin.last_name,
          email : this.inputs.company_admin.email,
          phone : this.inputs.company_admin.phone,
          password : this.inputs.company_admin.password,
          roles : this.inputs.roles
        }
      };

      this.preloader = true;
      if (this.modalTitle == "Edit") {

        axiosPost(CUSTOMER_UPDATE, requestPayload)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
            // $("#demo-add-edit-Modal").modal("hide");
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            
            this.preloader = false;
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
        axiosPost(CUSTOMER_STORE, requestPayload)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
            // $("#demo-add-edit-Modal").modal("hide");

          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            // $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    setRole() {
      axiosGet(CUSTOMER_ROLE)
        .then((res) => {
          this.inputs.roles = { 0: res.data.id };
        })
        .catch((error) => {

        });
    },
  },
  mounted() {

    this.setRole();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.preloader = false;
  },
};
</script>
